// import { yupResolver } from '@hookform/resolvers/yup';
// import Button from '@ui/Button';
// import TextArea from '@ui/TextArea';
// import Typography from '@ui/Typography';
// import React from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import { FaUser } from 'react-icons/fa';
// import { useFilePicker } from 'use-file-picker';
// import * as yup from 'yup';
// import JoinFormEditAvatarStep from './JoinFormEditAvatarStep';

// const schema = yup.object().shape({
//   message: yup
//     .string()
//     .required('Please provide a brief message about yourself')
//     .min(10, 'Message must be at least 10 characters')
//     .max(255, 'Message must be at most 255 characters'),
// });

// function JoinFormFinalStep(props) {
//   const { onSubmit, onBack } = props;

//   const [showImageEditor, setShowImageEditor] = React.useState(false);
//   const [avatarImage, setAvatarImage] = React.useState(null);

//   const [openFileSelector, { filesContent, loading, errors: fileErrors }] =
//     useFilePicker({
//       readAs: 'DataURL',
//       accept: 'image/*',
//       multiple: false,
//       maxFileSize: 5, // in megabytes
//     });

//   const form = useForm({
//     defaultValues: {
//       message: '',
//     },
//     mode: 'onChange',
//     resolver: yupResolver(schema),
//   });

//   const {
//     control,
//     handleSubmit,
//     formState: { errors },
//   } = form;

//   React.useEffect(() => {
//     if (filesContent && filesContent[0]) {
//       setShowImageEditor(true);
//     }
//   }, [filesContent]);

//   const handleFormSubmit = (data) => {
//     onSubmit({
//       ...data,
//       avatar: avatarImage,
//     });
//   };

//   const handleImageSubmit = (file) => {
//     if (file) {
//       setAvatarImage(
//         Object.assign(file, {
//           preview: URL.createObjectURL(file),
//         }),
//       );
//       setShowImageEditor(false);
//     }
//   };

//   const showFileSelector = () => {
//     openFileSelector();
//   };

//   if (showImageEditor) {
//     return (
//       <JoinFormEditAvatarStep
//         image={filesContent[0].content}
//         onSubmit={handleImageSubmit}
//       />
//     );
//   }

//   return (
//     <div className="flex w-full flex-1 flex-col gap-12">
//       <Typography variant="h1">Set Up Your Account</Typography>

//       <form
//         onSubmit={handleSubmit(handleFormSubmit)}
//         className="flex flex-col gap-6">
//         <div className="flex items-center gap-4">
//           <div className="h-20 w-20 rounded-full">
//             {avatarImage ? (
//               <img
//                 src={avatarImage.preview}
//                 alt="avatar"
//                 className="h-full w-full rounded-full"
//               />
//             ) : (
//               <div className="h-full w-full bg-primary-light-1 p-5">
//                 <FaUser className="h-full w-full text-primary" />
//               </div>
//             )}
//           </div>
//           <Button
//             variant="outlined"
//             color="primary"
//             onClick={showFileSelector}
//             type="button">
//             Upload Picture
//           </Button>
//         </div>

//         <Controller
//           name="message"
//           control={control}
//           render={({ field: { ref, ...rest } }) => (
//             <TextArea
//               label="Tell us more about yourself"
//               required
//               {...rest}
//               error={errors.message?.message}
//             />
//           )}
//         />

//         <div className="mt-2 flex w-full items-center justify-between">
//           <Button
//             type="button"
//             variant="outlined"
//             color="primary"
//             onClick={onBack}>
//             Back
//           </Button>

//           <Button type="submit" variant="filled" color="primary">
//             Apply
//           </Button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default JoinFormFinalStep;

import { useFilePicker } from 'use-file-picker';
import Button from '@ui/Button';
import React, { useEffect, useRef } from 'react';
import * as yup from 'yup';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Typography from '@ui/Typography';
import TextArea from '@ui/TextArea';
import { FaUser } from 'react-icons/fa';
import JoinFormEditAvatarStep from './JoinFormEditAvatarStep';
import { defaults, pick } from 'lodash-es';
import Checkbox from '@/components/next-ui/Checkbox';

const schema = yup.object().shape({
  message: yup
    .string()
    // .required('Please provide a brief message about yourself')
    // .min(10, 'Message must be at least 10 characters')
    .max(255, 'Message must be at most 255 characters')
    .nullable()
    .notRequired(),
  agreeToTerms: yup.boolean().isTrue('You must agree to the terms of service'),
});

function JoinFormFinalStep(props) {
  const { onSubmit, onBack, formData, handleFormData } = props;

  const [showImageEditor, setShowImageEditor] = React.useState(false);
  const [avatarImage, setAvatarImage] = React.useState(
    formData ? formData.avatar : null,
  );

  const [openFileSelector, { filesContent, loading, errors: fileErrors }] =
    useFilePicker({
      readAs: 'DataURL',
      accept: 'image/*',
      multiple: false,
      maxFileSize: 5, // in megabytes
    });

  const defaultValues = defaults(pick(formData, ['message', 'agreeToTerms']), {
    message: '',
    agreeToTerms: false,
  });

  const form = useForm({
    defaultValues: defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    getValues,
  } = form;

  React.useEffect(() => {
    if (filesContent && filesContent[0]) {
      setShowImageEditor(true);
    }
  }, [filesContent]);

  const handleFormSubmit = (data) => {
    onSubmit({
      ...data,
      avatar: avatarImage,
    });
  };

  const handleFormBack = () => {
    onBack({...getValues(), avatar: avatarImage});
  }

  const handleImageSubmit = (file) => {
    if (file) {
      setAvatarImage(
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      );
      setShowImageEditor(false);
    }
  };

  const showFileSelector = () => {
    openFileSelector();
  };

  const formValues = useWatch({ control });

  useEffect(() => {
    const values = getValues();
    handleFormData((prevFormData) => ({
      ...prevFormData,
      avatar: avatarImage,
    }));
  }, [formValues]);

  if (showImageEditor) {
    return (
      <JoinFormEditAvatarStep
        image={filesContent[0].content}
        onSubmit={handleImageSubmit}
      />
    );
  }

  return (
    <div className="flex h-full w-full flex-1 flex-col gap-4">
      <Typography variant="h3">Tell us a bit more about yourself</Typography>

      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="flex h-full w-full flex-col">
        <div className="flex w-full flex-1 flex-col gap-4 overflow-y-auto">
          <div className="flex items-center gap-4">
            <div className="h-20 w-20 rounded-full">
              {avatarImage ? (
                <img
                  src={avatarImage.preview}
                  alt="avatar"
                  className="h-full w-full rounded-full"
                />
              ) : (
                <div className="h-full w-full bg-primary-light-1 p-5">
                  <FaUser className="h-full w-full text-primary" />
                </div>
              )}
            </div>
            <Button
              variant="outlined"
              color="primary"
              onClick={showFileSelector}
              type="button">
              Upload Picture
            </Button>
          </div>

          <Controller
            name="message"
            control={control}
            render={({ field: { ref, ...rest } }) => (
              <TextArea
                label="Tell us more about yourself"
                // required
                {...rest}
                error={errors.message?.message}
              />
            )}
          />
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <Controller
                name="agreeToTerms"
                control={control}
                render={({ field: { onChange } }) => (
                  <Checkbox
                    onChange={onChange}
                    className="border-text-disabled font-extrabold"
                  />
                )}
              />

              <Typography variant="body2" component="div">
                I have read and agree to the
                <Typography
                  target="_blank"
                  component="a"
                  variant="body2"
                  href="https://www.neki.io/terms-and-conditions"
                  className="mx-0.5 underline hover:text-text-hyperlink">
                  terms of service
                </Typography>
              </Typography>
            </div>
            {errors.agreeToTerms?.message && (
              <Typography variant="caption" color="error">
                {errors.agreeToTerms?.message}
              </Typography>
            )}
          </div>
        </div>
        <div className="flex w-full justify-between pt-3">
          <Button variant="outlined" color="primary" onClick={handleFormBack}>
            Back
          </Button>

          <Button variant="filled" color="primary" type="submit">
            Apply
          </Button>
        </div>
      </form>
    </div>
  );
}

export default JoinFormFinalStep;
